import {callApi} from "./api";
import * as contract from "../contract";

// Joining a board: the owner invites, the person invited accepts or declines.

// Sends an invitation. Throws (with the server's reason) when the address has no account or the person is already on the
// board or already invited.
export const inviteMember = (boardId: string, emailAddress: string, role: contract.MemberRole, kiosk: boolean = false) =>
    callApi(contract.invitations.inviteMember, { body: { boardId, emailAddress, role, kiosk } });

export const getBoardInvitationsQuery = async (boardId: string): Promise<contract.BoardInvitation[]> => {
    const { invitations } = await callApi(contract.invitations.getBoardInvitations, { params: { boardId } });

    return invitations;
};

export const cancelInvitationQuery = (invitationId: string) =>
    callApi(contract.invitations.cancelInvitation, { body: { invitationId } });

export const respondToInvitationQuery = (invitationId: string, accept: boolean) =>
    callApi(contract.invitations.respondToInvitation, { body: { invitationId, accept } });
